import { c as _c } from "react/compiler-runtime";
import { FileText, Users, Building, Shield, MessageSquare, ThumbsUp } from "lucide-react";
import { ProcessPhase } from "./types";
import { DoorbellIcon } from "./icons";

// New icons for the updated flow
const UpdatePreferencesIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="w-8 h-8" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.1053 22.5V18.6563L24.7934 11.7813C24.975 11.5938 25.1768 11.4584 25.3987 11.375C25.6206 11.2917 25.8425 11.25 26.0645 11.25C26.3066 11.25 26.5386 11.2969 26.7605 11.3907C26.9825 11.4844 27.1842 11.625 27.3658 11.8125L28.4855 12.9688C28.6469 13.1563 28.773 13.3646 28.8638 13.5938C28.9546 13.8229 29 14.0521 29 14.2813C29 14.5104 28.9596 14.7448 28.8789 14.9844C28.7982 15.224 28.6671 15.4375 28.4855 15.625L21.8276 22.5H18.1053ZM19.9211 20.625H21.0711L24.7329 16.8125L24.1882 16.2188L23.6132 15.6563L19.9211 19.4375V20.625ZM8.42105 22.5C7.75526 22.5 7.18526 22.2552 6.71118 21.7657C6.23711 21.2761 6 20.6875 6 20V10C6 9.3125 6.23711 8.724 6.71118 8.2344C7.18526 7.7448 7.75526 7.5 8.42105 7.5H18.1053L25.3684 15V18.75H22.9474V16.25H16.8947V10H8.42105V20H15.6842V22.5H8.42105ZM24.1882 16.2188L23.6132 15.6563L24.7329 16.8125L24.1882 16.2188Z" fill="#7F2525" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BuyerJourneyPhases: ProcessPhase[] = [{
  title: "Discovery and Visits",
  subtitle: "(Cyclical till bought)",
  steps: [{
    icon: <UpdatePreferencesIcon />,
    title: "Update Preferences"
  }, {
    icon: <MessageSquare className="w-8 h-8 text-red-900" />,
    title: "Share Feedback"
  }, {
    icon: <ThumbsUp className="w-8 h-8 text-red-900" />,
    title: "Shortlist"
  }, {
    icon: <DoorbellIcon />,
    title: "Visit"
  }]
}, {
  title: "Settlement and Documentation",
  steps: [{
    icon: <Users className="w-8 h-8 text-red-900" />,
    title: "Meeting"
  }, {
    icon: <FileText className="w-8 h-8 text-red-900" />,
    title: "Token MOU"
  }, {
    icon: <Building className="w-8 h-8 text-red-900" />,
    title: "Legal & Loan"
  }, {
    icon: <Shield className="w-8 h-8 text-red-900" />,
    title: "Closure"
  }]
}];